import { ActionTree, MutationTree, GetterTree } from 'vuex';

import RegistrationService from '@/api/RegistrationService';
import { IRouterProps } from '@/router/interfaces/router-props.interface';

import { Item, Registration } from './registrationTypes';
import Module from '../interfaces/module.interface';
import { RootState } from '../types';
import { getPropsFromRoute } from '@/router/router-utils';

export const state: Registration = new Registration();

const registrationService = new RegistrationService();

const factory = async ({ store, route }: IRouterProps) => {
  const load = async () => {
    const context = getPropsFromRoute(route);

    if (
      context.auth === 'manager' &&
      context.routeRequirements.managerHaveBusiness
    ) {
      await store.dispatch('registration/REFRESH_BUSINESS_REGISTRATION');
    }
  };

  await load();

  store.watch((s, getters) => getters['business/getBusinessState'], load);
};

const actions: ActionTree<Registration, RootState> = {
  async REFRESH_BUSINESS_REGISTRATION(context) {
    const businessRegistration = await registrationService.checkProgress();

    if (businessRegistration.data) {
      context.dispatch(
        'SET_BUSINESS_REGISTRATION',
        businessRegistration.data.items
      );
    }
  },
  SET_BUSINESS_REGISTRATION(context, payload: Registration) {
    context.commit('setBusinessRegistration', payload);
  }
};

const mutations: MutationTree<Registration> = {
  setBusinessRegistration(state, payload: Item[]) {
    state.List = payload;
  }
};

const getters: GetterTree<Registration, RootState> = {
  getBusinessRegistration(state) {
    return state.List;
  },
  hasPendingRegistration(state) {
    if (state.List) {
      return state.List.some(
        (registration: any) =>
          registration.businessSignupSteps[0].status === 'pending'
      );
    }

    return false;
  }
};

const namespaced: boolean = true;

export const registration: Module<Registration, RootState> = {
  namespaced,
  initializer: {
    factory,
    provide: 'RegistrationStore',
    requires: ['BusinessStore'],
    on: 'BeforeEachRoute'
  },
  state,
  actions,
  mutations,
  getters
};
